export default __webpack_public_path__ + "static/media/father.fdaabac3.jpg";